module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4866abf7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 14
// module chunks = 0